import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Box } from '@material-ui/core';
import { ReactComponent as LanguageSVG } from './assets/language.svg';
import { ReactComponent as GenderSVG } from './assets/gender.svg';
import { useStylesMentorTags } from './styles';
import { MentorCardProps } from './interface';

const MentorTags: FC<MentorCardProps> = ({ mentor }) => {
  const classes = useStylesMentorTags();
  const [t, i18n] = useTranslation();

  const languageLabel = new Intl.DisplayNames([i18n.language], {
    type: 'language',
  });

  return (
    <Box className={classes.mentorTagsContainer}>
      <Box component="span" className={classes.languageWrapper}>
        <Typography
          component="span"
          variant="body1"
          className={classes.iconWrapper}
        >
          <LanguageSVG className={classes.icon} />
        </Typography>
        {mentor?.details?.languages &&
          mentor?.details?.languages.map((language: string, index: number) => {
            return (
              <>
                <Typography
                  component="span"
                  variant="body1"
                  className={classes.languageLabel}
                >
                  {language && languageLabel.of(language)}
                </Typography>
                {index < mentor?.details?.languages!.length - 1 && (
                  <Typography component="span" className={classes.divider}>
                    {' '}
                    |{' '}
                  </Typography>
                )}
              </>
            );
          })}
      </Box>
      <Box className={classes.genderWrapper}>
        <Typography
          component="span"
          variant="body1"
          className={classes.iconWrapper}
        >
          <GenderSVG className={classes.icon} />
        </Typography>
        <Typography
          component="span"
          variant="body1"
          className={classes.languageLabel}
        >
          {t(`v2.global.label_gender_${mentor?.details?.gender.toLowerCase()}`)}
        </Typography>
      </Box>
    </Box>
  );
};

export default MentorTags;
